// extracted by mini-css-extract-plugin
export default {"TransportDetailsForm":"TransportDetailsForm_TransportDetailsForm__Tg0Ya","ShippingDateInput":"TransportDetailsForm_ShippingDateInput__TtzFE"};